import { defaultConfig, getCurrentEnv } from './appConstants';
import { NetworkHelper } from './network';

/**
 * @fileoverview Fetches and caches property config from OAuth backend.
 * Used by flow packages to get feature flags and URLs (e.g. iosPasswordRule, redirectPaytmDeepLink).
 * Falls back to defaultConfig when the API fails.
 */

let config = null;

/**
 * Fetches a single property from the property-config API. Results are cached in memory.
 * @param {string} property - Config key (e.g. 'iosPasswordRule', 'redirectPaytmDeepLink', 'logoutConsentChecked').
 * @returns {Promise<string|boolean|object>} Resolved value for the property, or defaultConfig[property] on error.
 */
export const fetchPropertyConfig = async property => {
	console.log(config, 'config');
	if (config) {
		return config[property];
	}

	try {
		const response = await fetch(`${getCurrentEnv()}/oauth_fe_config/property-config?ver=1.1`);
		if (!response.ok) {
			throw new Error('Failed to fetch config');
		}

		config = await response.json();
		return config[property];
	} catch (error) {
		console.error(error);
		return defaultConfig[property];
	}
};
//   })();
